import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert } from 'src/raksme/models/classes/alert';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  public alerts: Subject<Alert> = new Subject();

  constructor() { }
}
